<template>
  <v-layout justify-space-between px-auto>
    <v-flex>
      <tree :all-proj-active="allProjectsActive" :tree-data="getProjects"></tree>
    </v-flex>
  </v-layout>
</template>

<script>
import Tree from "./tree";

export default {
  async mounted() {
    await this.$store.dispatch("project/getProjects");
  },
  beforeMount() {
    if (this.$route.name === 'projects')
      this.allProjectsActive = true;
  },
  data() {
    return {
      projects: null,
      allProjectsActive: false
    }
  },
  computed: {
    getProjects() {
      let projects = this.$store.getters["project/getProjects"];
      if (projects === 'null') return;
      let parentsAndChilds = this.projTreeParentsChilds(projects);
      return parentsAndChilds;
    },
  },
  watch: {
    getProjects(newProjects) {
      let mapOpen = newProjects.map((parent, i) => {
        if (this.projects === null || this.projects[i] === undefined) { // s'ils n'existent pas encore
          return this.childMatchRoute(parent);
        }else if (this.childMatchRoute(parent)) {
          return true;
        } else if (this.projects[i].uuid === parent.uuid) 
          return this.projects[i].open;
        // else projet supprimé
      });
      this.projects = newProjects;
      this.projects.forEach((proj, i) => this.$set(this.projects[i], 'open', mapOpen[i]));
    },
    $route(route) {
      if (route.name === 'projects')
        this.allProjectsActive = true;
      else this.allProjectsActive = false;
      if (!this.projects || !this.projects.length) return;
      this.projects.forEach((parent, i) => {
        if (this.childMatchRoute(parent)) {
          this.projects[i].open = true;
        }
      });
    //   // this.projects.forEach((proj, i) => this.$set(this.projects[i], 'open', mapOpen[i]));
    }
  },
  methods: {
    childMatchRoute(parent) {
      let routeUuid = this.$router.currentRoute.params.uuid;
      for (let child of parent.childs) {
        if (child.uuid === routeUuid)
          return true;
      }
      return false;
    }
  },
  components: {
    Tree
  }
};
</script>
